export const Banner = () => {
  return (
    <div className="container">
      <header>
        <div className="headerText">
          <h1>Enjoy Shopping</h1>
          {/* <p>Enjoy shopping</p> */}
        </div>
      </header>
    </div>
  );
};
